import { Skeleton } from "../../../components/Skeleton";

const TIER_CARD_COUNT = 5;

function TierProgressCardSkeleton() {
    return (
        <div className="p-4 flex w-[350px] min-h-[calc(100vh-300px)] rounded-[10px] min-w-[350px] flex-col shadow-[0_1px_2px_-1px_rgba(0,0,0,0.10),_0_1px_3px_0_rgba(0,0,0,0.10)] bg-white">
            <div className="flex flex-col gap-5">
                <Skeleton className="h-[130px] w-[130px]" />
                <div className="flex flex-col gap-1">
                    <Skeleton className="h-6 w-32" />
                    <Skeleton className="h-4 w-full max-w-[280px]" />
                </div>
                <div className="flex flex-col gap-7">
                    {[1, 2, 3].map((item) => (
                        <div key={item} className="flex flex-col gap-3">
                            <div className="flex items-center justify-between">
                                <Skeleton className="h-4 w-40" />
                                <Skeleton className="h-4 w-16" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export function TierProgressCardsSkeleton() {
    return (
        <>
            {Array.from({ length: TIER_CARD_COUNT }).map((_, index) => (
                <TierProgressCardSkeleton key={index} />
            ))}
        </>
    );
}
